import { h } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, EffectFade } from 'swiper';
import { useMemo } from 'preact/hooks';

SwiperCore.use([Autoplay, EffectFade]);

const PromoBar = ({
  messages,
  autoPlayDelay,
  background,
  slideClass,
  sliderProps = {},
  ...props
}) => {
  const formattedMessages = useMemo(
    () =>
      messages
        .filter((msg) => msg.content)
        .map((msg) => ({
          ...msg,
          links: msg.links.filter((item) => item.label && item.link),
        })),
    [messages],
  );

  if (!formattedMessages.length) {
    return null;
  }

  return (
    <div {...props} style={{ background }}>
      <div className="overflow-hidden">
        <Swiper
          loop={formattedMessages.length > 1}
          effect="fade"
          {...(autoPlayDelay > 0
            ? {
                autoplay: {
                  delay: autoPlayDelay * 1000,
                },
              }
            : {})}
          {...sliderProps}
        >
          {formattedMessages.map((message) => (
            <SwiperSlide
              key={message.id}
              className="[&:not(.swiper-slide-visible)]:!opacity-0 !h-auto"
            >
              <div className={`flex ${slideClass}`}>
                <div
                  className="content [&_a]:underline [&_a:hover]:no-underline promo-bar-text [&_*]:promo-bar-text"
                  dangerouslySetInnerHTML={{ __html: message.content }}
                ></div>
                <div className="btns flex items-center flex-none">
                  {message.links.map((item) => (
                    <a
                      href={item.link}
                      key={item.label}
                      className="promo-bar-text-link hover:no-underline"
                    >
                      {item.label}
                    </a>
                  ))}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default PromoBar;
